import React from "react";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const DownloadAppSection = () => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });

	return (
		<div className="footer-apps">
			<h3 className="footer-column-title subheading-2">
				{footerTexts.getText({ id: "section.download_apps", defaultText: "Descarga apps" })}
			</h3>
			<div className="footer-apps__badges">
				<a
					href="https://apps.apple.com/us/app/makemake-app/id6469707768?platform=iphone"
					className="focusable-red footer-store-badge"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						className="img-fluid"
						src="/img/makemake-app/apple-store-badget.png"
						alt={footerTexts.getText({
							id: "apps.apple.alt",
							defaultText: "Abrir pestaña para descarga en la app store",
						})}
					/>
				</a>
				<a
					href="https://play.google.com/store/apps/details?id=com.makemake.app"
					className="focusable-red footer-store-badge"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						className="img-fluid"
						src="/img/makemake-app/google-play-badget.png"
						alt={footerTexts.getText({
							id: "apps.google.alt",
							defaultText: "Abrir pestaña para descarga en google play",
						})}
					/>
				</a>
				<a
					href="https://makemake.app"
					className="focusable-red footer-apps__link"
					target="_blank"
					rel="noopener noreferrer"
					aria-label={footerTexts.getText({
						id: "apps.website.aria",
						defaultText: "Sitio web de la app MakeMake",
					})}
				>
					<span className="text-center">
						{footerTexts.getText({ id: "apps.website.line1", defaultText: "Más información" })}
						<br />
						{footerTexts.getText({ id: "apps.website.line2", defaultText: "App MakeMake" })}
					</span>
				</a>
			</div>
		</div>
	);
};
